import {Col, Container, Row} from "react-bootstrap";
import elements from "../styles/settings/elements.module.scss";
import React from "react";
import AllGames from "../components/AllGames";
import {Helmet} from "react-helmet";
import classes from "../styles/pages/home-page.module.scss";
import VerticalAd from "../components/adsense/VericalAd";
import {LEFT_SLOT, RIGHT_SLOT, SLOT1, SLOT2} from "../storage/constants/adsense";
import TrendingApps from "../components/TrendingApps";
import HorizontalAd from "../components/adsense/HorizontalAd";
import TrendingGames from "../components/TrendingGames";

function Games() {
    return(
        <>
            <Helmet>
                <title>Games</title>
                <meta
                    name="description"
                    content="Discover all our free games."
                />
            </Helmet>

            <Container fluid>
                <Row>
                    <Col xl={2} className="d-none d-xl-flex justify-content-center">
                        <VerticalAd adSlot={LEFT_SLOT} />
                    </Col>

                    <Col xs={12} xl={8} className={elements.mainContent}>
                        <header className={elements.introduction}>
                            <h1 className={elements.title}>Games</h1>
                            <p className={elements.description}>
                                Discover all our free games.
                            </p>
                        </header>

                        <HorizontalAd adSlot={SLOT1} />

                        <AllGames/>

                        <HorizontalAd adSlot={SLOT2} />
                    </Col>

                    <Col xl={2} className="d-none d-xl-flex justify-content-center">
                        <VerticalAd adSlot={RIGHT_SLOT} />
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Games;